

import {userLangArr} from './common';
import {i18n} from "../i18n";
/* 字符串过滤当前语言，匹配对应语言
  'zh,ar'过滤为['中文'，'英文']
*/
const filtersLangArr = function(thisArr){
    if(!thisArr){
        return thisArr;
    }else{
        // 参数
        let arr = thisArr.split(',');
        // 语言列表
        let langarr=userLangArr;
        // 初始txt
        let newLangtxt='';
        console.log(arr);
        arr.forEach((item,index) => {
            for(var li=0;li<langarr.length;li++){
            if(item===langarr[li].key){
                if(index>=arr.length-1){
                    newLangtxt+=langarr[li].name
                }else{
                    newLangtxt+=(langarr[li].name+',');
                }
                break;
            }
            }
        });
        return newLangtxt;
    }
}

/**
 * 小时翻译
 * @param type 类型 -1-永久 1-15分钟 2-30分钟 3-1小时 4-12小时 5-24小时 6-48小时 7-30天
 * @param lang 语言
 * @returns {*}
 */
const liveBannedTrans = function(type) {
  switch (type) {
    case -1: return "";
    case 1: return i18n.t("m.minute", { "msg_ss": 15 });
    case 2: return i18n.t("m.minute", { "msg_ss": 30 });
    case 3: return i18n.t("m.xx_hour", { "msg_ss": 1 });
    case 4: return i18n.t("m.xx_hours", { "msg_ss": 12 });
    case 5: return i18n.t("m.xx_hours", { "msg_ss": 24 });
    case 6: return i18n.t("m.xx_hours", { "msg_ss": 48 });
    case 7: return i18n.t("m.xx_days", { "msg_ss": 30 });
    case 8: return i18n.t("m.xx_days", { "msg_ss": 5 });
    case 9: return i18n.t("m.xx_days", { "msg_ss": 7 });
    case 10: return i18n.t("m.xx_days", { "msg_ss": 15 });
    case 11: return i18n.t("m.xx_year", { "msg_ss": 1 });
    case 12: return i18n.t("m.xx_years", { "msg_ss": 3 });
  }

  switch (type) {
    case -1: return "";
    case 1: return "15 minutes";
    case 2: return "30 minutes";
    case 3: return "1 hour";
    case 4: return "12 hours";
    case 5: return "24 hours";
    case 6: return "48 hours";
    case 7: return "30 days";
    case 8: return "5 days";
    case 9: return "7 days";
    case 10: return "15 days";
    case 11: return "1 year";
    case 12: return "15 years";
  }
  return type;
}
export default { filtersLangArr, liveBannedTrans };



// WEBPACK FOOTER //
// ./src/utils/filters.js